/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"; 
import { Link } from "react-router-dom";

const Header = ({varGoToMain}) => {
  return (
    <header id="header">
      {varGoToMain === -1?null
      :varGoToMain?
        <Link to={'/Main'} className="hd-logo">더나은물류</Link>
      :
        <div className="hd-logo">더나은물류</div>
      }
    </header>
  );
}
export default Header;